import React, { FC, useState, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import {
  LogsModuleEnum,
  useUserManagementLogListingPage,
} from '../user-management-log/list/user-management-log-listing-page.hook';
import { UserManagementLogList } from '../user-management-log/list/components/user-management-log-list.component';

type PageProps = ParamsProps & RouteComponentProps;

export const NewsArticleLogPage: React.FC<PageProps> = (props: PageProps) => {
  const { id } = useParams<{ id: string }>();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  // style
  // const { classes } = useStyles();
  const tableTitle = useMemo(() => Translation('news.article.history'), []);

  // custom-hook
  const { filterState, userManagementLogList, dynamicFilterOptions, isLoading, setFilterState, refreshData, onSort } =
    useUserManagementLogListingPage({
      initialParams: { module: LogsModuleEnum.NEWS },
      onChangeQueryParams: props.onChangeQueryParams,
    });

  return (
    <>
      <PruFilter
        title={Translation('auditLog.userManagementLog.list.filter.title')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'search',
            initialValue: filterState.search,
            displayName: Translation('auditLog.userManagementLog.list.filter.search'),
            tooltip: Translation('audit.log.tooltip'),
          },
          {
            type: PruFilterItemType.DROPDOWN,
            field: 'activity',
            choices: dynamicFilterOptions.activity ?? [],
            displayName: Translation('auditLog.userManagementLog.list.activity'),
          },
          {
            type: PruFilterItemType.DROPDOWN,
            field: 'activityStatus',
            choices: dynamicFilterOptions.activityStatus ?? [],
            displayName: Translation('auditLog.userManagementLog.list.status'),
          },
          {
            type: PruFilterItemType.DROPDOWN,
            field: 'service',
            choices: dynamicFilterOptions.service ?? [],
            displayName: Translation('auditLog.userManagementLog.list.filter.service'),
          },
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'lastUpdatedBy',
            initialValue: filterState.lastUpdatedBy,
            displayName: Translation('auditLog.userManagementLog.list.lastUpdatedBy'),
          },
          {
            type: PruFilterItemType.DATE_RANGE,
            fieldTo: 'createdAtTo',
            fieldFrom: 'createdAtFrom',
            displayName: Translation('auditLog.userManagementLog.list.createdDate'),
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            ...data,
          })
        }
        fetchData={refreshData}
      />
      <UserManagementLogList
        tableTitle={tableTitle}
        module={LogsModuleEnum.NEWS}
        isLoading={isLoading}
        userManagementLogList={userManagementLogList}
        onRefresh={refreshData}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
        onSort={onSort}
      />
    </>
  );
};
